const BaseForm = ["articles", "title", "description", "company"];
const ConveyorsForm = [
  "customer",
  "author",
  "address",
  "customerPhone",
  "customerRepresentative",
  "dateOfSale",
  "representativePhone",
  "specificationNumber",
  "request_form",
  "dateOfIncident",
  "details",
  "dateOfInstallation",
  "plannedOperatingTime",
  "actualOperatingTime",
  "conveyorLength",
  "tapeDesignation",
  "tapeSpeed",
  "efficiency",
  "angleOfInclination",
  "materialDensity",
  "material",
  "lumpiness",
  "dropHeight",
  "minAirTemperature",
  "materialTemperature",
  "angleRollers",
  "diameterDriveDum",
  "diameterTailDum",
  "diameterBypassDum",
  "tapeDockingType",
  "elementId"
];
const CrushingSparesForm = [
  "customer",
  "phone",
  "request_form",
  "service_engineer",
  "dateOfCompletion",
  "dateOfSale",
  "dateOfIncident",
  "request_reason",
  "incident_description",
  "article_element",
  "article_original",
  "po_n",
  "equipment",
  "serial_number",
  "year",
  "damage_1",
  "articles",
  "damage_description",
  "customer_requirements",
  "optime_unit",
  "custom_unit",
  "optime_actual"
];
const CrushingArmorsAndComponentsForm = [
  "customer",
  "phone",
  "request_form",
  "service_engineer",
  "dateOfCompletion",
  "dateOfSale",
  "dateOfIncident",
  "request_reason",
  "incident_description",
  "article_element",
  "article_original",
  "po_n",
  "disassembling",
  "disassembling_article_element",
  "disassembling_article_original",
  "disassembling_po_n",
  "equipment",
  "serial_number",
  "year",
  "damage_1",
  "articles",
  "damage_description",
  "damage_2",
  "customer_requirements",
  "optime_unit",
  "custom_unit",
  "optime_plan",
  "optime_actual",
  "optime_average",
  "weight",
  "material",
  "size_1",
  "size_2",
  "gap",
  "stroke",
  "a_size"
];
const GrindingForm = [
  "customer",
  "phone",
  "request_form",
  "service_engineer",
  "dateOfRequest",
  "dateOfSale",
  "dateOfIncident",
  "request_reason",
  "incident_description",
  "article_element",
  "article_original",
  "trace_number",
  "damage_1",
  "articles",
  "damage_description",
  "damage_2",
  "customer_requirements",
  "equipment",
  "serial_number",
  "efficiency",
  "optime_unit",
  "optime_plan",
  "optime_actual",
  "optime_average",
  "material",
  "size_1",
  "size_2",
  "hole_size",
  "total_mill_loading",
  "mill_rotation",
  "size_grinding_media",
  "material_grinding_media",
  "loading_volume"
];
const HeaderForm = ["themes", "process", "group"];
const EMCUserFields = ["responsible_team", "priority", "work_type", "deadline", "reason_of_request"];
const HydrotransportForm = [
  "customer",
  "phone",
  "request_form",
  "service_engineer",
  "dateOfPurchase",
  "bill_num",
  "dateOfBill",
  "dateOfReceipt",
  "dateOfCommissioning",
  "dateOfIncident",
  "dateOfRequest",
  "request_reason",
  "incident_description",
  "article_element",
  "article_original",
  "po_n",
  "equipment",
  "serial_number",
  "year",
  "damage_1",
  "articles",
  "damage_description",
  "customer_requirements"
];
const AddNewAccountForm = [
  "fio",
  "email",
  "price_list",
  "sales_chanel",
  "list_companies",
  "responsible_person",
  "show_contains_of_equipment",
  "show_full_element_number",
  "show_full_oem_number",
  "country",
  "company_custom"
];

export {
  AddNewAccountForm,
  BaseForm,
  ConveyorsForm,
  CrushingSparesForm,
  CrushingArmorsAndComponentsForm,
  GrindingForm,
  HeaderForm,
  HydrotransportForm,
  EMCUserFields
};
